import { render } from "./App.vue?vue&type=template&id=91ac35c6&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=91ac35c6&lang=css"
import "./App.vue?vue&type=style&index=1&id=91ac35c6&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91ac35c6"]])

export default __exports__